import styled from "styled-components";
import {COLOR} from "src/service/constant/color";

const LoginWrap = styled.div`
  margin-bottom: 240px;

  > div {
    margin-top: 38px;
  }

  > p {
    margin: 24px 0 0 0;
    font-size: 12px;
    text-align: center;
    font-family: NotoSansRegular, sans-serif;
    >a{
      color: ${COLOR.sub1};
      padding-left: 6px;
    }
  }
`
export {
    LoginWrap
}